module.exports = __webpack_public_path__ + "img/m_logo.6088f714.png";